import Vue from 'vue'
import Router from 'vue-router'
import Share from '../components/share.vue'
import linkJump from "../components/link-jump";
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/share',
      name: 'share',
      component: Share,
      caseSensitive:true
    },    
    {
      path: '/Share',
      name: 'Share',
      component: linkJump,
      caseSensitive:true
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js